// AboutUs.js
import React, { useState, useEffect, useRef } from 'react';
import './Pages/PagesCss/AboutUs.css';
import { useNavigate } from 'react-router-dom';

// ─── Icons ────────────────────────────────────────────────────────────────────
const Icons = {
  Mission: (p) => (
    <svg width="22" height="22" viewBox="0 0 24 24" fill="none" {...p}>
      <circle cx="12" cy="12" r="3" stroke="currentColor" strokeWidth="1.8"/>
      <path d="M12 2V5M12 19V22M2 12H5M19 12H22" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round"/>
      <path d="M4.93 4.93L7.05 7.05M16.95 16.95L19.07 19.07M4.93 19.07L7.05 16.95M16.95 7.05L19.07 4.93" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round"/>
    </svg>
  ),
  Heart: (p) => (
    <svg width="22" height="22" viewBox="0 0 24 24" fill="none" {...p}>
      <path d="M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 0 0 0-7.78z" stroke="currentColor" strokeWidth="1.8" strokeLinejoin="round"/>
    </svg>
  ),
  Shield: (p) => (
    <svg width="22" height="22" viewBox="0 0 24 24" fill="none" {...p}>
      <path d="M12 3L4 7V12C4 16.42 7.58 21 12 21C16.42 21 20 16.42 20 12V7L12 3Z" stroke="currentColor" strokeWidth="1.8" strokeLinejoin="round"/>
      <path d="M9 12L11 14L15 10" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"/>
    </svg>
  ),
  Zap: (p) => (
    <svg width="22" height="22" viewBox="0 0 24 24" fill="none" {...p}>
      <path d="M13 2L4.5 13.5H12L11 22L19.5 10.5H12L13 2Z" stroke="currentColor" strokeWidth="1.8" strokeLinejoin="round"/>
    </svg>
  ),
  Globe: (p) => (
    <svg width="22" height="22" viewBox="0 0 24 24" fill="none" {...p}>
      <circle cx="12" cy="12" r="9" stroke="currentColor" strokeWidth="1.8"/>
      <path d="M12 3C12 3 8 7 8 12C8 17 12 21 12 21M12 3C12 3 16 7 16 12C16 17 12 21 12 21M3 12H21" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round"/>
    </svg>
  ),
  Code: (p) => (
    <svg width="22" height="22" viewBox="0 0 24 24" fill="none" {...p}>
      <path d="M16 18L22 12L16 6M8 6L2 12L8 18" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"/>
    </svg>
  ),
  Users: (p) => (
    <svg width="22" height="22" viewBox="0 0 24 24" fill="none" {...p}>
      <circle cx="9" cy="7" r="3" stroke="currentColor" strokeWidth="1.8"/>
      <path d="M3 20C3 17.24 5.69 15 9 15C12.31 15 15 17.24 15 20" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round"/>
      <path d="M16 11C17.66 11 19 9.66 19 8C19 6.34 17.66 5 16 5" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round"/>
      <path d="M21 20C21 17.79 19.21 16 17 16" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round"/>
    </svg>
  ),
  ArrowRight: (p) => (
    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" {...p}>
      <path d="M5 12H19M19 12L13 6M19 12L13 18" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"/>
    </svg>
  ),
  Star: (p) => (
    <svg width="16" height="16" viewBox="0 0 24 24" fill="currentColor" {...p}>
      <path d="M12 2L15.09 8.26L22 9.27L17 14.14L18.18 21.02L12 17.77L5.82 21.02L7 14.14L2 9.27L8.91 8.26L12 2Z"/>
    </svg>
  ),
  Check: (p) => (
    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" {...p}>
      <path d="M5 12L10 17L19 7" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round"/>
    </svg>
  ),
  Rocket: (p) => (
   <svg width="22" height="22" viewBox="0 0 24 24" fill="none" {...p}>
    <path d="M4 4C4 2.89543 4.89543 2 6 2H14L20 8V20C20 21.1046 19.1046 22 18 22H6C4.89543 22 4 21.1046 4 20V4Z" stroke="currentColor" strokeWidth="1.8" strokeLinejoin="round"/>
    <path d="M14 2V8H20" stroke="currentColor" strokeWidth="1.8" strokeLinejoin="round"/>
    <path d="M8 13H16M8 17H13" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round"/>
  </svg>
  ),
  Twitter: (p) => (
    <svg width="18" height="18" viewBox="0 0 24 24" fill="currentColor" {...p}>
      <path d="M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-4.714-6.231-5.401 6.231H2.744l7.737-8.835L2.25 2.25h6.985l4.26 5.632 4.749-5.632zm-1.161 17.52h1.833L7.084 4.126H5.117L17.083 19.77z"/>
    </svg>
  ),
  LinkedIn: (p) => (
    <svg width="18" height="18" viewBox="0 0 24 24" fill="currentColor" {...p}>
      <path d="M16 8a6 6 0 016 6v7h-4v-7a2 2 0 00-2-2 2 2 0 00-2 2v7h-4v-7a6 6 0 016-6zM2 9h4v12H2z"/>
      <circle cx="4" cy="4" r="2"/>
    </svg>
  ),
};

// ─── Animated counter ─────────────────────────────────────────────────────────
const Counter = ({ end, suffix = '', duration = 2000 }) => {
  const [count, setCount] = useState(0);
  const ref = useRef(null);
  const started = useRef(false);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting && !started.current) {
          started.current = true;
          const startTime = performance.now();
          const step = (now) => {
            const progress = Math.min((now - startTime) / duration, 1);
            const eased = 1 - Math.pow(1 - progress, 3);
            setCount(Math.floor(eased * end));
            if (progress < 1) requestAnimationFrame(step);
            else setCount(end);
          };
          requestAnimationFrame(step);
        }
      },
      { threshold: 0.5 }
    );
    if (ref.current) observer.observe(ref.current);
    return () => observer.disconnect();
  }, [end, duration]);

  return <span ref={ref}>{count.toLocaleString()}{suffix}</span>;
};

// ─── Data ─────────────────────────────────────────────────────────────────────
const STATS = [
  { end: 10,   suffix: 'M+', label: 'Files processed',    color: '#3B82F6' },
  { end: 30,   suffix: '+',  label: 'PDF tools built',    color: '#10B981' },
  { end: 195,  suffix: '+',  label: 'Countries reached',  color: '#8B5CF6' },
  { end: 99.9, suffix: '%',  label: 'Uptime guaranteed',  color: '#F59E0B' },
];

const VALUES = [
  {
    icon: Icons.Heart,
    title: 'Free, always',
    desc: "We built QuickPDFs because PDF tools shouldn't cost money. Core features are free forever no trials, no watermarks on the free tier basics, no bait-and-switch.",
    color: '#EF4444',
    bg: '#FEF2F2',
  },
  {
    icon: Icons.Shield,
    title: 'Privacy first',
    desc: 'Your documents are your business. Files are processed in memory and permanently deleted within one hour. We never read, sell, or analyse your content.',
    color: '#10B981',
    bg: '#ECFDF5',
  },
  {
    icon: Icons.Zap,
    title: 'Speed matters',
    desc: 'Nobody wants to wait for a PDF to compress. We obsess over processing performance so your output is ready in seconds, not minutes.',
    color: '#F59E0B',
    bg: '#FFFBEB',
  },
  {
    icon: Icons.Globe,
    title: 'Built for everyone',
    desc: 'Whether you\'re a student in Lagos, a lawyer in Tokyo, or a designer in Berlin QuickPDFs works on any device, in any browser, in any language.',
    color: '#3B82F6',
    bg: '#EFF6FF',
  },
];

const TIMELINE = [
  {
    year: '2023',
    title: 'The idea',
    desc: "Frustrated with bloated, expensive PDF tools, the D-Tech Studios team started building a simpler alternative in their spare time.",
    tag: 'Origin',
  },
  {
    year: 'Early 2024',
    title: 'QuickPDFs launches',
    desc: 'We shipped the first 8 tools Merge, Split, Compress, PDF to Word, and a few more. The response from early users was overwhelmingly positive.',
    tag: 'Launch',
  },
  {
    year: 'Mid 2024',
    title: '1 million files processed',
    desc: 'Within 6 months of launch we crossed 1M files processed proof that people genuinely needed a fast, no-nonsense PDF toolkit.',
    tag: 'Milestone',
  },
  {
    year: 'Late 2024',
    title: '30+ tools & growing',
    desc: 'We expanded the toolkit to 30+ tools covering every major PDF workflow OCR, batch processing, redaction, comparison, and more.',
    tag: 'Growth',
  },
  {
    year: '2025',
    title: 'Pro & Business plans',
    desc: 'To keep the free tier truly free, we launched paid plans for power users and teams funding the infrastructure without compromising access.',
    tag: 'Monetisation',
  },
  {
    year: '2026',
    title: '10M+ files & counting',
    desc: "We're now processing millions of files every month across 195+ countries. The mission making PDF tools accessible to everyone continues.",
    tag: 'Today',
  },
];

// ─── Component ────────────────────────────────────────────────────────────────
export default function AboutUs() {
  const navigate = useNavigate();

  return (
    <div className="ab-page">

      {/* ── Hero ──────────────────────────────────────────── */}
      <section className="ab-hero">
        <div className="ab-hero-grid-bg" aria-hidden="true" />
        <div className="ab-hero-glow" aria-hidden="true" />

        <div className="ab-container">
          <div className="ab-hero-inner">
            <div className="ab-hero-eyebrow">
              <span className="ab-eyebrow-tag">D-Tech Studios</span>
              <span className="ab-eyebrow-sep">·</span>
              <span className="ab-eyebrow-text">About QuickPDFs</span>
            </div>

            <h1 className="ab-hero-title">
              PDF tools that work<br />
              <span className="ab-highlight">for everyone.</span>
            </h1>

            <p className="ab-hero-sub">
              QuickPDFs is a product of <strong>D-Tech Studios</strong> built with one belief:
              the tools you need every day should never cost money or steal your privacy.
            </p>

            <div className="ab-hero-actions">
              <button className="ab-btn ab-btn--primary" onClick={() => navigate('/PDFTools')}>
                Explore the tools <Icons.ArrowRight />
              </button>
              <button className="ab-btn ab-btn--ghost" onClick={() => navigate('/contact')}>
                Get in touch
              </button>
            </div>
          </div>

          {/* Brand mark */}
          <div className="ab-hero-brand" aria-hidden="true">
            <div className="ab-brand-ring ab-brand-ring--1" />
            <div className="ab-brand-ring ab-brand-ring--2" />
            <div className="ab-brand-ring ab-brand-ring--3" />
            <div className="ab-brand-core">
              <Icons.Rocket />
            </div>
          </div>
        </div>
      </section>

      {/* ── Stats ─────────────────────────────────────────── */}
      <section className="ab-stats-section">
        <div className="ab-container">
          <div className="ab-stats-grid">
            {STATS.map((s, i) => (
              <div className="ab-stat" key={i}>
                <div className="ab-stat-num" style={{ color: s.color }}>
                  <Counter end={s.end} suffix={s.suffix} />
                </div>
                <div className="ab-stat-label">{s.label}</div>
                <div className="ab-stat-bar" style={{ background: s.color }} />
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* ── Story section ─────────────────────────────────── */}
      <section className="ab-story-section">
        <div className="ab-container">
          <div className="ab-story-grid">
            <div className="ab-story-left">
              <span className="ab-section-label">Our story</span>
              <h2 className="ab-section-title">
                Built out of<br />frustration
              </h2>
              <div className="ab-story-body">
                <p>
                  Every PDF tool we found either had an annoying paywall, a 25-file-per-day limit, or slapped a watermark on your output the moment you needed something done. The free options felt like demos, not tools.
                </p>
                <p>
                  So the team at <strong>D-Tech Studios</strong> built QuickPDFs starting with 8 core tools and the promise that the most important features would always be free. No catch.
                </p>
                <p>
                  Today QuickPDFs has 30+ tools, serves users in 195+ countries, and has processed more than 10 million files. It's still built with the same philosophy: fast, private, free.
                </p>
              </div>
              <div className="ab-story-checks">
                {[
                  'No account required for free tools',
                  'Files deleted within 1 hour always',
                  'No ads, no tracking, no bloat',
                  '100% browser-based, no installs',
                ].map((item, i) => (
                  <div key={i} className="ab-check-row">
                    <span className="ab-check-icon"><Icons.Check /></span>
                    {item}
                  </div>
                ))}
              </div>
            </div>

            {/* Decorative code block */}
            <div className="ab-story-right">
              <div className="ab-code-window">
                <div className="ab-code-bar">
                  <span className="ab-code-dot ab-code-dot--r" />
                  <span className="ab-code-dot ab-code-dot--y" />
                  <span className="ab-code-dot ab-code-dot--g" />
                  <span className="ab-code-filename">quickpdfs.config.js</span>
                </div>
                <pre className="ab-code-body">{`const QuickPDFs = {
  company:    "D-Tech Studios",
  product:    "QuickPDFs.net",
  tools:      30+,
  free:       true,        // always
  watermarks: false,
  tracking:   false,
  fileLimit:  "none",      // pro plan
  deleteAfter: "1 hour",

  values: [
    "privacy first",
    "speed always",
    "free forever",
    "built for everyone",
  ],

  mission: "PDF tools that work",
};

export default QuickPDFs;`}</pre>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* ── Values ────────────────────────────────────────── */}
      <section className="ab-values-section">
        <div className="ab-container">
          <div className="ab-section-head">
            <span className="ab-section-label">What we stand for</span>
            <h2 className="ab-section-title">Our values</h2>
            <p className="ab-section-sub">Four principles that guide every decision we make at D-Tech Studios.</p>
          </div>
          <div className="ab-values-grid">
            {VALUES.map((v, i) => (
              <div
                key={i}
                className="ab-value-card"
                style={{ '--vc': v.color, '--vbg': v.bg, animationDelay: `${i * 0.1}s` }}
              >
                <div className="ab-value-icon">
                  <v.icon />
                </div>
                <h3 className="ab-value-title">{v.title}</h3>
                <p className="ab-value-desc">{v.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* ── Timeline ──────────────────────────────────────── */}
      <section className="ab-timeline-section">
        <div className="ab-container ab-container--narrow">
          <div className="ab-section-head">
            <span className="ab-section-label">Our journey</span>
            <h2 className="ab-section-title">How we got here</h2>
          </div>

          <div className="ab-timeline">
            {TIMELINE.map((item, i) => (
              <div key={i} className={`ab-timeline-item${i % 2 === 0 ? ' ab-tl-left' : ' ab-tl-right'}`}>
                <div className="ab-tl-connector">
                  <div className="ab-tl-dot" />
                </div>
                <div className="ab-tl-card">
                  <div className="ab-tl-meta">
                    <span className="ab-tl-year">{item.year}</span>
                    <span className="ab-tl-tag">{item.tag}</span>
                  </div>
                  <h3 className="ab-tl-title">{item.title}</h3>
                  <p className="ab-tl-desc">{item.desc}</p>
                </div>
              </div>
            ))}
            {/* Timeline end dot */}
            <div className="ab-tl-end">
              <div className="ab-tl-end-dot">→</div>
            </div>
          </div>
        </div>
      </section>

      {/* ── Company section ───────────────────────────────── */}
      <section className="ab-company-section">
        <div className="ab-container">
          <div className="ab-section-head">
            <span className="ab-section-label">Behind the product</span>
            <h2 className="ab-section-title">D-Tech Studios</h2>
            <p className="ab-section-sub">
              QuickPDFs is one of our flagship products. We build software that solves real problems fast.
            </p>
          </div>

          <div className="ab-company-card">
            <div className="ab-company-left">
              <div className="ab-company-logo">
                <span>D</span>
              </div>
              <div className="ab-company-info">
                <h3 className="ab-company-name">D-Tech Studios</h3>
                <p className="ab-company-tagline">We build. You use. It's free.</p>
              </div>
            </div>
            <p className="ab-company-desc">
              D-Tech Studios is a software development studio focused on building useful, accessible tools for everyday people.
              QuickPDFs is our most-used product, but we're constantly working on new ideas.
              Our philosophy: ship fast, keep it simple, charge fairly, never compromise on privacy.
            </p>
            <div className="ab-company-actions">
              <a href="https://d-techstudios.com" target="_blank" rel="noreferrer" className="ab-btn ab-btn--outline">
                Visit D-Tech Studios <Icons.ArrowRight />
              </a>
            </div>
          </div>
        </div>
      </section>

      {/* ── Tech stack ────────────────────────────────────── */}
      <section className="ab-tech-section">
        <div className="ab-container">
          <div className="ab-section-head">
            <span className="ab-section-label">Under the hood</span>
            <h2 className="ab-section-title">Built with care</h2>
            <p className="ab-section-sub">The technology that makes QuickPDFs fast, reliable, and secure.</p>
          </div>
          <div className="ab-tech-grid">
            {[
              { name: 'React',           role: 'Frontend UI',         color: '#61DAFB', bg: '#E8F9FD' },
              { name: 'NPM',   role: 'Package management',    color: '#CB3837', bg: '#F5F3FF' },
              { name: 'React Native',         role: 'Mobile app',  color: '#0A84FF', bg: '#EBF5EA' },
              { name: 'App Store',         role: 'iOS distribution',    color: '#F59E0B', bg: '#FEF2F2' },
              { name: 'Google Play',     role: 'Android distribution',    color: '#34A853', bg: '#FFFBEB' },
              { name: 'AWS / Cloudflare',role: 'CDN & infrastructure',color: '#F38020', bg: '#EFF6FF' },
            ].map((t, i) => (
              <div key={i} className="ab-tech-card" style={{ '--tc': t.color, '--tbg': t.bg }}>
                <div className="ab-tech-dot" />
                <div>
                  <p className="ab-tech-name">{t.name}</p>
                  <p className="ab-tech-role">{t.role}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* ── CTA ───────────────────────────────────────────── */}
      <section className="ab-cta-section">
        <div className="ab-container">
          <div className="ab-cta-inner">
            <div className="ab-cta-glow" aria-hidden="true" />
            <span className="ab-cta-eyebrow">From D-Tech Studios, with ❤️</span>
            <h2 className="ab-cta-title">
              QuickPDFs is free.<br />Go get something done.
            </h2>
            <p className="ab-cta-sub">
              30+ tools. No sign-up. No watermarks. Just pick one and start.
            </p>
            <div className="ab-cta-btns">
              <button className="ab-btn ab-btn--cta-primary" onClick={() => navigate('/PDFTools')}>
                Browse all tools <Icons.ArrowRight />
              </button>
              <button className="ab-btn ab-btn--cta-ghost" onClick={() => navigate('/contact')}>
                Say hello
              </button>
            </div>
          </div>
        </div>
      </section>

    </div>
  );
}